import bitcoin from 'assets/images/payment/cryptocurrencies/bitcoin.svg';
import bitcoinCash from 'assets/images/payment/cryptocurrencies/bitcoincash.svg';
import crypto from 'assets/images/payment/cryptocurrencies/crypto.svg';
import dai from 'assets/images/payment/cryptocurrencies/dai.svg';
import dash from 'assets/images/payment/cryptocurrencies/dash.svg';
import ethereum from 'assets/images/payment/cryptocurrencies/ethereum.svg';
import litecoin from 'assets/images/payment/cryptocurrencies/litecoin.svg';
import sol from 'assets/images/payment/cryptocurrencies/sol.svg';
import properT from 'assets/images/payment/cryptocurrencies/properT.svg';
import tether from 'assets/images/payment/cryptocurrencies/tether.svg';
import usdc from 'assets/images/payment/cryptocurrencies/usdc.svg';
import weth from 'assets/images/payment/cryptocurrencies/weth.png';
import xrp from 'assets/images/payment/cryptocurrencies/xrp.svg';
import tron from 'assets/images/payment/cryptocurrencies/tron.svg';

export const currencies = [
   { title: 'BTC (Bitcoin)', value: 'bitcoin', currency: 'BTC' },
   { title: 'BCH (Bitcoin Cash)', value: 'bitcoinCash', currency: 'BCH' },
   { title: 'ETH (Ethereum)', value: 'ethereum', currency: 'ETH' },
   { title: 'LTC (Litecoin)', value: 'litecoin', currency: 'LTC' },
   { title: 'SOL (Solana)', value: 'sol', currency: 'SOL' },
   { title: 'USDT (Tether)', value: 'tether', currency: 'USDT' },
   { title: 'DAI (Dai)', value: 'dai', currency: 'DAI' },
   { title: 'USDC (USD Coin)', value: 'usdc', currency: 'USDC' },
   { title: 'WETH (Wrapped Ether)', value: 'weth', currency: 'WETH' },
   { title: 'DASH (Dash)', value: 'dash', currency: 'DASH' },
   { title: 'XRP (by Ripple)', value: 'xrp', currency: 'XRP' },
   { title: 'TRX (TRON)', value: 'tron', currency: 'TRX' },
   { title: 'ProperT (ProperT Token)', value: 'properT', currency: 'PROPT' },
];

export default {
   bitcoin,
   bitcoinCash,
   crypto,
   dai,
   dash,
   ethereum,
   litecoin,
   sol,
   properT,
   tether,
   usdc,
   weth,
   xrp,
   tron,
};
